<template>
  <div class="field" :class="question.errorMessage ? 'errorBorder' : ''">
    <div class="field-label title_text">
      {{ question.num }}、<span v-html="question.title"></span>
      <span v-if="question.must === 1" class="req">*</span>
    </div>
    <div class="ui-checkbox" v-for="(item,index) in question.options" :key="index"
         @click="selectCurrent(index,question.num,question)">
      <span class="jqcheckwrapper">
         <a class="jqcheck" :class="selected[index] ? 'jqchecked' : ''" href="javascript:;"></a>
       </span>
      <div class="labelCheckBox">{{ item }}</div>
    </div>
    <div class="errorMessage">{{ question.errorMessage }}</div>
  </div>
</template>
<script>
export default {
  props: {
    question: Object
  },
  data() {
    return {
      selected: [false, false, false, false, false, false, false, false, false, false, false, false, false],
      arrAnswer: new Set([])
    }
  },
  created() {
    const question = this.question;
    if (question.answer !== undefined && question.answer !== null) {
      let arr = question.answer.split(',');
      for(let i = 0; i < arr.length; i++) {
        let index = Number(arr[i].trim())
        if (arr[i] !== "") {
          if (typeof index === 'number' && !isNaN(index)){
            this.arrAnswer.add(index)
            this.$set(this.selected, index - 1, true);
          }
        }
      }
    }
  },
  methods: {
    selectCurrent(i, num, question) {
      if (this.selected[i]) {
        this.$set(this.selected, i, false)
        this.arrAnswer.delete(i + 1)
      } else {
        if (question.mustSelectNum !== null && this.arrAnswer.size >= question.mustSelectNum){
          return
        }
        this.$set(this.selected, i, true)
        this.arrAnswer.add(i + 1)
      }
      if((this.arrAnswer.size > 0 && question.mustSelectNum === null) || (question.mustSelectNum !== null && this.arrAnswer.size === question.mustSelectNum)){
        question.finish = 1
        question.errorMessage = ''
      }else {
        question.finish = 0
      }
      if (question.mustSelectNum !== null) {
        if (this.arrAnswer.size < question.mustSelectNum) {
          question.errorMessage = '您已经选择了' + this.arrAnswer.size + '项,少选择了' + (question.mustSelectNum - this.arrAnswer.size) + '项'
        } else {
          question.errorMessage = ''
        }
      }
      let answer = [...this.arrAnswer].join(',')
      question.answer = answer
      console.log(answer)
      this.$emit('listenToChildEvent', num, answer, question)
    }
  }
}
</script>
<style lang="stylus" scoped>
p {
  max-width: 12rem;
}

.ui-checkbox {
  background: none repeat scroll 0 0 #fff;
  border-bottom: 1px solid #d5d5d5;
  border-right: 1px solid #d5d5d5;
  font-size: 16px;
  min-height: 43px;
  position: relative;
  overflow: hidden;
}

.labelCheckBox {
  display: block;
  margin-left: 40px;
  padding: 12px 10px 10px 0;
  cursor: pointer;
}

.jqcheckwrapper {
  display: block;
  float: left;
  margin: 11px 4px 10px 11px;
}

.jqcheck {
  background-color: #fafafa;
  border: 1px solid #cacece;
  padding: 9px;
  border-radius: 3px;
  display: inline-block;
  position: relative;
}

a.jqchecked {
  background-color: #53a4f4 !important;
  background: url(/images/checkedbox.png) no-repeat scroll center top transparent;
  background-size: cover;
  height: 3px;
  vertical-align: middle;
  width: 3px;
  border: none;
}

.req {
  color: red
}

.title_text {
  font-weight: bold;
}
</style>
